import { Link } from 'react-router-dom';
import s from './LegalFooter.module.scss';

// Shared legal footer — Terms / Privacy links + copyright. Used on the login
// page, the authenticated app shell, and the contractor onboarding flow so the
// legal pages are reachable from everywhere, not just by typing the URL (T-102).
export function LegalFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className={s.footer}>
      <Link to="/legal/eula">Terms of Use</Link>
      <span aria-hidden="true"> · </span>
      <Link to="/legal/privacy">Privacy Policy</Link>
      <span aria-hidden="true"> · </span>
      <span>© {year} ultimumIT</span>
    </footer>
  );
}
